/* ==========================================================================
   The Pure Beauty — Cadeau mystère ajouté automatiquement
   - Panier avec au moins un produit payant  => 1 cadeau mystère (et un seul)
   - Panier sans produit payant               => cadeau retiré
   Variante du cadeau : window.TPB_MYSTERY_GIFT (layout/theme.liquid).
   Le tiroir et la page panier se mettent à jour tout seuls (tpb.js écoute
   les appels /cart/update et re-rend le panier).
   ========================================================================== */
(function () {
  'use strict';
  var giftId = Number(window.TPB_MYSTERY_GIFT || 0);
  if (!giftId) return;

  var busy = false;
  var again = false;

  function updateGift(qty) {
    var updates = {};
    updates[giftId] = qty;
    return window.fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftQty = 0;
        var hasPaid = false;
        (cart.items || []).forEach(function (item) {
          if (Number(item.variant_id) === giftId) giftQty += item.quantity;
          else hasPaid = true;
        });
        if (hasPaid && giftQty !== 1) return updateGift(1);
        if (!hasPaid && giftQty > 0) return updateGift(0);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(check, 300); }
      });
  }

  var schedule = (function () {
    var t;
    return function () { clearTimeout(t); t = setTimeout(check, 400); };
  })();

  document.addEventListener('tpb:cart:added', schedule);
  document.addEventListener('tpb:cart:changed', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();